/**
 * DashboardPage Component
 * 
 * User dashboard showing test attempts and starting new tests.
 * Refactored with:
 * - Custom hook for state management (useDashboard)
 * - Separate components for UI sections
 * - Constants and types extracted
 * 
 * @module pages/DashboardPage
 */
import React from 'react';

// Hooks
import { useDashboard } from '../hooks';

// Components
import {
  DashboardHeader,
  WelcomeCard,
  AttemptsList,
  InstructionsModal
} from '../components/dashboard';

/**
 * Loading screen component
 */
const LoadingScreen: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-neutral">
    <p className="text-gray-600">Chargement...</p>
  </div>
);

/**
 * DashboardPage - Main user dashboard
 */
const DashboardPage: React.FC = () => {
  const {
    attempts,
    remainingAttempts,
    loading,
    starting,
    showInstructions,
    setShowInstructions,
    handleStartTest,
    handleLogout
  } = useDashboard();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen bg-neutral p-4">
      <div className="max-w-xl mx-auto">
        {/* Header */}
        <DashboardHeader onLogout={handleLogout} />

        {/* Welcome Card */}
        <WelcomeCard 
          remainingAttempts={remainingAttempts}
          onStartClick={() => setShowInstructions(true)}
        />

        {/* Previous Attempts */}
        <AttemptsList attempts={attempts} />
      </div>

      {/* Instructions Modal */}
      {showInstructions && (
        <InstructionsModal
          onClose={() => setShowInstructions(false)}
          onStart={() => {
            setShowInstructions(false);
            handleStartTest();
          }}
          starting={starting}
        />
      )}
    </div>
  );
};

export default DashboardPage;
